import React from "react";

function DashboardMiddlePane(props) {
  return <div className="body_content_wrap">{props.children}</div>;
}

export default DashboardMiddlePane;
